<template>
  <RcDialog :model-value="true" title="Search Companies" :width="mobile ? '100%' : '500px'" :fullscreen="mobile"
    @closeDialog="emit('closeDialog')">
    <div class="pa-4">
      <v-text-field v-model="searchText" label="Search by Name or ID" prepend-inner-icon="mdi-magnify"
        variant="outlined" density="compact" hide-details class="mb-4" autofocus clearable rounded="lg"></v-text-field>
      <v-list lines="two" max-height="400" class="overflow-y-auto bg-surface rounded-lg" border>
        <template v-if="props.loading">
          <v-list-item class="text-center py-6">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-list-item>
        </template>
        <template v-else-if="filteredCompanies.length === 0">
          <v-list-item title="No companies found" class="text-center text-medium-emphasis py-6"></v-list-item>
        </template>
        <template v-else>
          <v-list-item v-for="c in filteredCompanies" :key="c.id" :title="c.name" :subtitle="'ID: ' + c.id"
            @click="selectCompany(c)" class="mb-1" rounded="md" hover>
            <template v-slot:append>
              <v-icon color="primary" size="small">mdi-chevron-right</v-icon>
            </template>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </RcDialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';

import RcDialog from '@/v3/components/library/dialog/RcDialog.vue';
import ContentUtils from '@/utils/ContentUtils';

const props = defineProps({
  companies: { type: Array, required: true },
  loading: { type: Boolean, default: false }
});

const emit = defineEmits(['closeDialog']);

const router = useRouter();
const { mobile } = useDisplay();

const searchText = ref('');

const filteredCompanies = computed(() => {
  if (!searchText.value) return props.companies;
  const s = searchText.value.toLowerCase();
  return props.companies.filter(
    c => {
      const addressHq = c.obj.addressHq().find();
      return c.name.toLowerCase().includes(s) ||
        c.id.toLowerCase().includes(s) ||
        addressHq.jurisdiction().includes(s) ||
        addressHq.city().includes(s) ||
        addressHq.street().includes(s)
    }
  );
});

const selectCompany = (c) => {
  emit('closeDialog');
  router.push({ path: '/portal/v3/admin/companies', query: { action: 'details', selectedId: ContentUtils.baseEncode(c.id) } });
};
</script>
